import { Paper, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from './linkService';

type Props = {
  link: Link;
}

export const LinkCard: React.FC<Props> = ({ link }) => {
  return (
    <Paper sx={{
      padding: '1em',
      marginTop: '1em'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <Typography variant="h4">{link.name}</Typography>
          <Typography variant="body2" color="text.secondary">{link.url}</Typography>
        </div>
        <div>
          <RouterLink to={`/edit-link/${link.id}`}>
            <EditIcon />
          </RouterLink>
        </div>
      </div>
    </Paper>
  );
}
